import { render, staticRenderFns } from "./PasswordChangeSection.vue?vue&type=template&id=92961ef2&scoped=true&"
import script from "./PasswordChangeSection.vue?vue&type=script&lang=js&"
export * from "./PasswordChangeSection.vue?vue&type=script&lang=js&"
import style0 from "./PasswordChangeSection.vue?vue&type=style&index=0&id=92961ef2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92961ef2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ganttpro/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('92961ef2')) {
      api.createRecord('92961ef2', component.options)
    } else {
      api.reload('92961ef2', component.options)
    }
    module.hot.accept("./PasswordChangeSection.vue?vue&type=template&id=92961ef2&scoped=true&", function () {
      api.rerender('92961ef2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/views/profileSettings/components/profile/PasswordChangeSection.vue"
export default component.exports